import api from "@/lib/api";

export function getGuestSessionId() {
  let id = localStorage.getItem("lm_guest_session");
  if (!id) {
    id = (typeof crypto !== "undefined" && crypto.randomUUID)
      ? crypto.randomUUID()
      : `g_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("lm_guest_session", id);
  }
  return id;
}

export const guestService = {
  generate: (topic, readingLevel = "standard") =>
    api.post("/guest/generate", { topic, guest_session_id: getGuestSessionId(), reading_level: readingLevel }).then((r) => r.data),
  getCourse: (id) =>
    api.get(`/guest/course/${id}`, { params: { guest_session_id: getGuestSessionId() } }).then((r) => r.data.course),
  sectionAudio: (id, idx) =>
    api.get(`/guest/course/${id}/audio/${idx}`, { params: { guest_session_id: getGuestSessionId() } }).then((r) => r.data.audio),
  featured: () => api.get("/guest/featured").then((r) => r.data.course),
  featuredAudio: (idx) => api.get(`/guest/featured/audio/${idx}`).then((r) => r.data.audio),
  publicPlaylist: () => api.get("/guest/public-playlist").then((r) => r.data.courses),
  publicCourse: (id) => api.get(`/guest/public/${id}`).then((r) => r.data.course),
  publicAudio: (id, idx) => api.get(`/guest/public/${id}/audio/${idx}`).then((r) => r.data.audio),
};
